
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import NumericId from "@/vue/components/NumericId.vue";
    import ApiClient from "@/utilities/ApiClient";
    import FileDownload from "@/utilities/FileDownload";
    import { ResourceAndTextOptions } from "@/model/pagePartOptions/ResourceAndTextOptions";
    import { ResourceAndTextLayout, ResourceContentType } from "@/model/Enums";

    @Component({ components: { NumericId } })
    export default class ResourceAndTextPart extends Vue {

        mounted(): void {
            // "briefing-resize-observer" is the 'sheet' div on the briefing page (Briefing.vue)
            const a = document.getElementsByClassName("briefing-resize-observer");
            if(a.length > 0) {
                const div = document.getElementsByClassName("briefing-resize-observer")[0];
                const resizeObserver = new ResizeObserver(entries => {
                    const width = div.getBoundingClientRect().width;
                    this.isNarrowScreen = width <= 600;

                    const resourceContainerWidth = (this.$refs.resourceContainer as HTMLElement)?.clientWidth ?? 300;
                    this.sixteenNineVideoHeight = resourceContainerWidth / (16.0 / 9.0);
                });
                resizeObserver.observe(div);
            }

            // if(this.options.contentType === ResourceContentType.Wistia) {
            //     //const wistiaUrl = `https://fast.wistia.com/embed/medias/${this.options.wistiaID}.jsonp`;
            //     console.log("loading wistia ", this.wistiaScriptUrl);
            //     const wistiaScript = document.createElement("script");
            //     wistiaScript.defer = true;
            //     wistiaScript.src = this.wistiaScriptUrl;
            //     wistiaScript.addEventListener("error", e => console.error("Failed to load Wistia script ", e));
            //     wistiaScript.addEventListener("abort", e => console.error("Loading Wistia script aborted ", e));
            //     wistiaScript.addEventListener("load", () => console.log("+++ loaded wistia script"));
            //     document.head.appendChild(wistiaScript);
            // }
        }

        // beforeDestroy(): void {
        //     if(this.options.contentType === ResourceContentType.Wistia) {
        //         const wistiaScript = document.querySelector(`script[src="${this.wistiaScriptUrl}"]`);
        //         if(wistiaScript) {
        //             document.head.removeChild(wistiaScript);
        //             console.log("unloaded wistia");
        //         }
        //         else {
        //             console.warn("failed to find and unload Wistia script - src=", this.wistiaScriptUrl);
        //         }
        //     }
        // }

        missingImage = "@/images/missing.png";

        @Prop({ default: new ResourceAndTextOptions() })
        options!: ResourceAndTextOptions;

        @Prop({ default: false })
        isAdminView!: boolean;

        isNarrowScreen: boolean = false;
        sixteenNineVideoHeight: number = 200;

        // so we can use in template
        resourceContentType: any = ResourceContentType;

        get shouldShowTextAtTop(): boolean {
            return this.options.layoutType === ResourceAndTextLayout.TextAbove || this.isNarrowScreen;
        }

        get shouldShowTextAtBottom(): boolean {
            return this.options.layoutType === ResourceAndTextLayout.TextBelow;
        }

        get shouldShowTwoColumns(): boolean {
            return !this.isNarrowScreen && (this.options.layoutType === ResourceAndTextLayout.TextOnLeft || this.options.layoutType === ResourceAndTextLayout.TextOnRight);
        }

        get shouldShowTextOnLeft(): boolean {
            return this.options.layoutType === ResourceAndTextLayout.TextOnLeft && !this.isNarrowScreen;
        }

        get shouldShowTextOnRight(): boolean {
            return this.options.layoutType === ResourceAndTextLayout.TextOnRight && !this.isNarrowScreen;
        }

        isValidPercent = () => this.options.widthPercent >= 10 && this.options.widthPercent <= 100;

        get resourceWidth(): string {
            return this.isValidPercent() ? `${this.options.widthPercent}%` : "50%";
        }

        get textWidth(): string {
            return this.isValidPercent() ? `${100 - this.options.widthPercent}%` : "50%";
        }

        get resourceHasRightMargin(): boolean {
            return this.options.layoutType === ResourceAndTextLayout.TextOnRight;
        }

        get resourceHasLeftMargin(): boolean {
            return this.options.layoutType === ResourceAndTextLayout.TextOnLeft;
        }

        get resourceUrl(): string {
            return this.options.resource?.sourceUrl ?? require("@/images/missing.png");
        }

        get iconUrl(): string {
            if(!this.options.resource.hasFile) return ApiClient.resolveUrl("api/file/icon?extension=nul");
            const filename = this.options.resource.filename;
            const dotAt = filename.lastIndexOf(".");
            const extension = dotAt === -1 || dotAt >= filename.length - 1 ? "" : filename.substr(dotAt + 1).toLowerCase();
            return ApiClient.resolveUrl(`api/file/icon?extension=${extension}`);
        }

        get vimeoUrl(): string {
            const idParts = this.options.vimeoID.split("/");
            if(idParts.length === 2) {
                return this.options.shouldAutoPlay
                    ? `https://player.vimeo.com/video/${idParts[0]}?h=${idParts[1]}&autoplay=1&loop=1&autopause=0`
                    : `https://player.vimeo.com/video/${idParts[0]}?h=${idParts[1]}`;
            }
            else {
                return this.options.shouldAutoPlay
                    ? `https://player.vimeo.com/video/${idParts[0]}?autoplay=1&loop=1&autopause=0`
                    : `https://player.vimeo.com/video/${idParts[0]}`;
            }
        }

        get wistiaCssClass(): any {
            const cssClass: any = { "wistia_embed": true };
            const key = `wistia_async_${this.options.wistiaID}`;
            cssClass[key] = true;
            if(this.options.shouldAutoPlay) {
                cssClass["autoPlay=true"] = true; // ffs...
            }
            return cssClass;
        }

        // get wistiaScriptUrl(): string { return `https://fast.wistia.com/embed/medias/${this.options.wistiaID}.jsonp`}

        // get wistiaIFrameUrl(): string { return `https://fast.wistia.net/embed/iframe/${this.options.wistiaID}`}

        async download() {
            FileDownload.download(this.options.resource);
        }

    }
